import { render, staticRenderFns } from "./AxManageUsersTable.vue?vue&type=template&id=1d8a451a&scoped=true&"
import script from "./AxManageUsersTable.vue?vue&type=script&lang=ts&"
export * from "./AxManageUsersTable.vue?vue&type=script&lang=ts&"
import style0 from "./AxManageUsersTable.vue?vue&type=style&index=0&id=1d8a451a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a451a",
  null
  
)

export default component.exports